import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/seo-articles';

export default function ArticleCards() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
            GTBuy Spreadsheet Guides &amp; Comparisons
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-lg mx-auto">
            In-depth articles to help you save money, compare agents, and shop smarter internationally.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-white rounded-lg border border-background-200/70 hover:border-primary-300 overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col gap-2 p-5 flex-1">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors whitespace-nowrap mt-1">
                  Read Article
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}